import { useAtom } from 'jotai';
import { currentProjectAtom } from '@/stores/editorStore';
import ChatPane from '@/components/Chat/ChatPane';
import PreviewPane from '@/components/Preview/PreviewPane';
import TopMenu from '@/components/Layout/TopMenu';

export default function NewEditor() {
  const [currentProject] = useAtom(currentProjectAtom);

  if (!currentProject) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-muted-foreground">Select or create a project to get started</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      {/* Top Menu Bar */}
      <TopMenu />

      {/* Main Content: Chat (Left) + Preview (Right) */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Pane: Chat Interface */}
        <div className="w-1/3 border-r flex flex-col">
          <ChatPane />
        </div>

        {/* Right Pane: Live Preview */}
        <div className="w-2/3 flex flex-col">
          <PreviewPane />
        </div>
      </div>
    </div>
  );
}
